<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
// import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import Loading from "@/components/c-loading";
import { saleService } from "../../../services/saleservice/sale.service";
import { saletransferService } from "../../../services/saleservice/saletransfer.service";
import i18n from "../../../i18n";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Sale Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Area,
    // Select,
    Search
  },
  watch: {
      valueExtend: function(newVal) { // watch it
        // console.log(newVal);
        let deposit = parseFloat(this.valueBookingAmount);
        let extend = parseFloat(newVal);

        this.valueLastBookingAmount = deposit + extend;
      }
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Booking",
      breadCrumb: {},
      
      sale: {},
      propertySelected: {},
      propertyData: {},
      customeryData: {},
      valueTransferDate: this.$moment().clone().format('YYYY-MM-DD'),
      valueSaleId: 0,
      valueSale: '',
      valueFee: 100,
      valueProperty: '',
      valuePropertyId: 0,
      valueFromCustomer: '',
      valueFromCustomerId: 0,
      valueToCustomer: '',
      valueToCustomerId: 0,
      valueSalePrice: 0,
      valueReason: '',

      valuePaymentMethod: 1,
      paymentMethodData: [],
      valueBankAccount: 0,
      bankAccountData: [],

    };
  },
  mounted() {

    this.valuePaymentMethod = 1;

    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);     
    }
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      saleService.getOne(id)
        .then(response => {

          // console.log(response);

          this.fetchingStats = true;
          if(response.data) {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

            this.sale = response.data;
            this.valueSaleId = this.sale.id;
            this.valueSale = this.sale.code;
            this.valueProperty = this.sale.property;
            this.valuePropertyId = this.sale.property_id;
            this.valueFromCustomer = `${this.sale.customer} (${this.sale.customer_en})`;
            this.valueFromCustomerId = this.sale.customer_id;
            this.valueSalePrice = this.sale.sale_price;
            // this.valueFee = this.sale.fee;
            
          }

          this.loadingSettings(response.setting);
        
        });
    },

    loadingSettings: function(setting) {

      // this.paymentMethodData = {data: setting.paymentmethods};
      // this.bankAccountData = {data: setting.bankaccounts};
      this.customeryData = {data: setting.customers};
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "booking-list"
          });

        }
      });
    },
    
    submitSave: function() {

      this.tryingToSubmit = true;

      let transfer = 
      {
        
        sale_id: this.valueSaleId,
        property_id: this.valuePropertyId,
        from_customer_id: this.valueFromCustomerId,
        to_customer_id: this.valueToCustomerId,
        sell_price: this.valueSalePrice,
        reason: this.valueReason,
        sale_transfer_status_id: 1,
        for_date: this.valueTransferDate,
        payment_method_id: this.valuePaymentMethod,
        bank_account_id: this.valueBankAccount,
        fee: this.valueFee,
        fee_of: 1
      };

      // console.log(this.valueTransferDate, JSON.stringify(transfer));

      saletransferService.insert(transfer)
        .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {

            if(response.data) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: false,
                confirmButtonColor: "#34c38f",
                confirmButtonText: i18n.t('general.success.yes')
              }).then(result => {
                if (!result.value) {

                    this.$router.push(this.$route.query.redirectFrom || {
                      name: "sale-list"
                    });

                    // let route = this.$router.resolve({ path: `/general/booking/receipt/${response.data.id}` });
                    // window.open(route.href);
                } 
              });
            } else {
              this.$swal.fire({
                title: i18n.t('general.invalid.title'),
                text: i18n.t('general.invalid.message'),
                icon: "error",
                confirmButtonColor: "#34c38f",
                confirmButtonText: i18n.t('general.ok')
              }).then(result => {
                if (result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "booking-list"
                  });
                } 
              });
            }
          }
        
      });
      
    },

    clearForm: function() {
      this.valueProperty = '';
      this.valuePropertyId = 0;
      this.valueFromCustomer = '';
      this.valueFromCustomerId = 0;
      this.valueToCustomer = '';
      this.valueToCustomerId = 0;
      this.valueSalePrice = 0;
      this.valueReason = ''
      this.valueTransferDate = this.$moment().clone().format('YYYY-MM-DD');
      this.valuePaymentMethod = 0;
      this.valueBankAccount = 0;

    },

    paymentMethodChanged: function(event) {

      if(event != 2 && event != 3) {
        this.valueBankAccount = 0;
      }
    },
  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('sale.list'),
        href: '/general/sale',
      }, {
        text: $t('sale.transfer-to-other'),
        active: true
      }]" :title="$t('sale.transfer-to-other')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('sale.list'),
        href: '/general/sale',
      }, this.breadCrumb]" :title="$t('sale.transfer-to-other')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">

              <div class="row">
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'sale_id'"
                    :disabled="true"
                    v-model="valueSale"
                    :label="'sale.text'"
                     /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'property_id'"
                    :disabled="true"
                    v-model="valueProperty"
                    :label="'property.text'"
                     /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'from+customer_id'"
                    :disabled="true"
                    v-model="valueFromCustomer"
                    :label="'sale.transfer.from-customer'"
                     /> 
                </div>
                
              </div>
              <div class="row">
                <div class="col-md-4">
                  <Input 
                    :type="'date'"
                    :id="'booking_date'"
                    v-model="valueTransferDate"
                    :label="'general.date'" 
                     /> 
                </div>
                <div class="col-md-4">
                  <Search 
                    :id="'to_customer_id'"
                    v-model="valueToCustomerId"
                    :editable="false"
                    :list="this.customeryData"
                    :label="'sale.transfer.to-customer'"  
                  />
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'number'"
                    :id="'fee'"
                    v-model="valueFee"
                    :last="'USD'"
                    :label="'sale.transfer.fee'" 
                     /> 
                </div>
              </div>
              <!-- <div class="row">
                <div class="col-md-6">
                  <Select
                    @change="paymentMethodChanged" 
                    :id="'payment_method_id'"
                    :auto="true"
                    v-model="valuePaymentMethod"
                    :list="this.paymentMethodData"
                    :label="'booking.payment-method'"
                     /> 
                </div>
                <div v-show="valuePaymentMethod == 2 || valuePaymentMethod == 3" class="col-md-6">
                  <Select
                    :id="'bank_account_id'"
                    v-model="valueBankAccount"
                    :list="this.bankAccountData"
                    :label="'payment.bank_account'"
                     /> 
                </div>
              </div> -->


              <div class="row" style="margin-top: 15px;">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12">
                  <Area 
                    :rows="8"
                    :id="'notation'"
                    v-model="valueReason"
                    :label="'sale.transfer.reason'"  />
                </div>
            </div>
          </div>
        </div>
      </div>
    </b-form> 

  </Layout>
</template>